





































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Button, SvgIcon } from "@brankas/web-ui";
import { namespace } from "vuex-class";
import PreviewModal from "@/components/preview-modal/PreviewModal.vue";
import { IEditSummaryData, ESummaryContentType } from "./index.dto";
import { TFileUpload } from "@/types";
import { fileToDataUrl } from "@/utils/common-utils";

const clientModule = namespace("client");

@Component({
  components: {
    Button,
    SvgIcon,
    PreviewModal,
  },
})
export default class EditSummary extends Vue {
  @clientModule.Action("getClientInfo") getClientInfo!: (
    clientId: string
  ) => void;

  @Prop({ type: Array, default: () => [] }) data!: IEditSummaryData[];
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "" }) subtitle!: string;

  ESummaryContentType = ESummaryContentType;
  showPreview = false;
  previewImage = "";
  previewTitle = "";

  setPreviewModal(open: boolean, title?: string, imageUrl?: string) {
    this.showPreview = open;
    this.previewImage = imageUrl || "";
    this.previewTitle = title || "";
  }

  async onClickFile(type: ESummaryContentType, fileData: TFileUpload) {
    let url;
    if (fileData.file) {
      url =
        type === ESummaryContentType.IMAGE
          ? await fileToDataUrl(fileData.file)
          : URL.createObjectURL(fileData.file);
    }
    if (fileData.signedUrl) {
      url = fileData.signedUrl;
    }

    // for type IMAGE
    if (type === ESummaryContentType.IMAGE) {
      this.setPreviewModal(true, fileData.fileName, url as string);
    }
    // for type FILE
    else {
      const link = document.createElement("a");
      link.href = url as string;
      link.download = fileData.fileName ?? "file";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  handleBack() {
    const { clientId } = this.$route.params;
    this.$router.push(`/client/${clientId}`, () =>
      // Refetch client info
      this.getClientInfo(clientId)
    );
  }
}
